import React from "react"
// import { Link } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
// import { makeStyles, useTheme } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
// import Button from "@material-ui/core/Button"
import Paper from "@material-ui/core/Paper"
// import useMediaQuery from "@material-ui/core/useMediaQuery"

const useStyles = makeStyles(theme => ({
  heroContainer: {
    marginTop: "2rem",
    position: "relative",
    height: "21rem",
    zIndex: -1,
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0)",
  },
  // h1: {
  //   width: "100%",
  //   color: theme.palette.common.white,
  //   fontWeight: 500,
  //   fontSize: "2.9375rem",
  //   marginLeft: "auto",
  //   marginRight: "auto",
  //   display: "inline-block",
  //   textTransform: "uppercase",
  //   [theme.breakpoints.down("xs")]: {
  //     fontSize: "2.25rem",
  //   },
  // },
  h1: {
    fontFamily: "Work Sans, sans-serif",
    fontSize: "2.5rem",
    fontWeight: 400,
    lineHeight: "1.2",
    letterSpacing: 3,
    padding: '1rem 0',
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  subtitle: {
    fontFamily: "Work Sans, sans-serif",
  },
  headerBox: {
    padding: "1.25rem",
    background: `rgba(0,0,0,0.5)`,
    color: "#fff",
    marginTop: "3rem",
    marginBottom: "2rem",
    borderRadius: 0,
    maxWidth: "60%",
    marginLeft: "auto",
    marginRight: "auto",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
}))

export default function Newsroom({ img, title }) {
  const classes = useStyles()
  // const theme = useTheme()
  // const matchesXS = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <>
      <div className={classes.heroContainer}>
        <div className={classes.overlay}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            style={{ position: "relative", height: "100%" }}
          >
            <Grid item xs={12} md={10}>
              <Paper className={classes.headerBox} elevation={0}>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography
                      variant="h1"
                      className={classes.h1}
                      align="center"
                    >
                      {title}
                    </Typography>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </div>
        {img}
        {/* <StaticImage
          src="../../assets/images/05-Andreatta-Waterscapes-Koi-Pond-Central-Point-Oregon.jpg"
          quality={90}
          placeholder="blurred"
          className={classes.imgWrapper}
          objectFit="cover"
          objectPosition="50% 25%"
          alt="Mature Backyard Waterfall Eagle Point Oregon"
        /> */}
      </div>
    </>
  )
}
